<template>
    <div class="content">
        <!-- eslint-disable vue/no-v-html -->
        <p
            v-if="textContent != null"
            v-html="textContent"
        />
        <!--eslint-enable-->
        <dynamic-table
            v-else
            :table-data="dynamicTableData"
        />
        <!-- eslint-disable vue/no-v-html -->
        <p
            v-if="description != null"
            class="description"
            v-html="description"
        />
        <!--eslint-enable-->
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTable.vue"
    import TableData from "@/models/tabledata"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class BittimittariVuorokaudenaikaanPohjautuvatTiedot extends Vue {
        get rightSlotData(): DynamicRightSlotData {
            return this.$store.getters.rightSlotData
        }

        get dynamicTableData() {
            return new TableData(this.rightSlotData?.tableData?.header ?? [], this.rightSlotData?.tableData?.data ?? [], null)
        }

        get slotData(): DynamicRightSlotData | null {
            return store.getters.rightSlotData as DynamicRightSlotData
        }

        get textContent() {
            return this.rightSlotData?.textContent
        }

        get description() {
            return this.rightSlotData?.description
        }
    }
</script>

<style scoped>
   /* Deep selectorilla tyyli saadaan vaikuttamaan kielitermin sisältämiin <p> tageihin */
   :deep(p) {
        margin-bottom: 1rem !important;
    }

    .description {
        background-color: var(--Traficom-main-color);
        color: #fff;
        padding:  10px;
    }
</style>
